import { httpClient } from "./_http"


/**
 * @param {{}} payload 
 * 请求参数：sstatus: "UNUSED" 未使用 , "USED" 已使用 , "EXPIRED" 已过期
 *  page 起始为0，如果不传则查出所有
 *  pageSize 起始为1，如果不传则查出所有
 */
export const queryCouponList = (payload) => {
  return httpClient.get(`/duckBill/coupon/queryCustomerCouponListByStatus`, {
    params: payload
  })
}

export function queryLatestCoupon() {
  return httpClient.get("/duckBill/coupon/queryLatestCustomerCouponActivity")
}

// templateId
export function queryCouponUsage(payload) {
  return httpClient.get("/duckBill/coupon/queryCustomerCouponUsageByTemplateId", {
    params: payload
  })
}

export function queryCouponRange(payload) {
  return httpClient.get("/duckBill/coupon/queryCustomerCouponIsCanBeUsedByBeginDateAndEndDate", {
    params: payload
  })
}


export function queryUnusedCouponAmount(payload) {
  return httpClient.get("/duckBill/coupon/queryCustomerCouponNumByStatus", {
    params: payload
  })
}


// WEBPACK FOOTER //
// ./src/api/coupon.js